module.exports = __webpack_public_path__ + "static/media/securing-web-applications.13933bd5.png";